import React from 'react';

const BulkModerationActions = ({ 
  selectedCount, 
  totalCount, 
  onSelectAll, 
  onBulkAction,
  isLoading,
  isAllSelected,
  activeStatus 
}) => {
  const handleAction = (action) => {
    if (action === 'reject') {
      const reason = prompt(
        'Please provide a reason for rejection:',
        'Does not meet marketplace guidelines'
      );
      if (reason !== null) {
        onBulkAction(action, reason);
      }
    } else {
      if (window.confirm(`Are you sure you want to ${action} ${selectedCount} listing(s)?`)) {
        onBulkAction(action);
      }
    }
  };
  
  const getAvailableActions = () => {
    const baseActions = [
      { 
        id: 'approve', 
        label: 'Approve', 
        icon: '✅', 
        bg: 'from-green-600 to-emerald-500',
        hoverBg: 'from-green-700 to-emerald-600'
      },
      { 
        id: 'reject', 
        label: 'Reject', 
        icon: '❌', 
        bg: 'from-red-600 to-red-500',
        hoverBg: 'from-red-700 to-red-600'
      },
      { 
        id: 'update_moderation_status', 
        label: 'Change Status', 
        icon: '⚙️', 
        bg: 'from-[#ff660e] to-orange-500',
        hoverBg: 'from-[#ff5500] to-orange-600'
      },
    ];
    
    return baseActions.filter(action => {
      if (activeStatus === 'approved' && action.id === 'approve') return false;
      return true;
    });
  };
  
  const actions = getAvailableActions();
  
  return (
    <div className="bg-gray-800 rounded-xl shadow-lg border border-gray-700 p-4 md:p-6">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="flex items-center gap-4">
            <div className="relative">
              <div className="w-14 h-14 rounded-full flex items-center justify-center bg-gradient-to-br from-[#ff660e] to-orange-400 ring-2 ring-gray-700">
                <span className="text-white font-bold text-lg">{selectedCount}</span>
              </div>
              {selectedCount > 0 && (
                <div className="absolute -top-1 -right-1 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center text-white text-xs font-bold ring-2 ring-gray-800">
                  !
                </div>
              )}
            </div>
            <div>
              <h3 className="font-semibold text-white">Bulk Moderation Actions</h3>
              <p className="text-sm text-gray-400">
                {selectedCount} of {totalCount} <span className="text-[#ff660e] capitalize">{activeStatus}</span> listings selected
              </p>
            </div>
          </div>
          
          <button
            onClick={onSelectAll}
            disabled={isLoading}
            className="px-4 py-2.5 rounded-lg text-sm font-medium border border-gray-600 text-gray-300 hover:text-white hover:border-[#ff660e] hover:bg-gray-700 transition-all duration-200 flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <span className="text-lg">{isAllSelected ? '☐' : '☑'}</span>
            <span>{isAllSelected ? 'Deselect All' : 'Select All'}</span>
          </button>
        </div>
        
        <div className="flex flex-wrap gap-3">
          {actions.map((action) => (
            <button
              key={action.id}
              onClick={() => handleAction(action.id)}
              disabled={isLoading || selectedCount === 0}
              className={`px-4 py-3 rounded-lg text-sm font-semibold text-white transition-all duration-200 hover:scale-[1.02] shadow-lg flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed bg-gradient-to-r ${action.bg} hover:${action.hoverBg}`}
            >
              {isLoading ? (
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              ) : (
                <>
                  <span>{action.icon}</span>
                  <span>{action.label}</span>
                </>
              )}
            </button>
          ))}
        </div>
      </div>
      
      {isLoading && (
        <div className="mt-6">
          <div className="flex items-center justify-between text-sm text-gray-400 mb-2">
            <span>Processing bulk action...</span>
            <span>{selectedCount} listings</span>
          </div>
          <div className="h-2 bg-gray-700 rounded-full overflow-hidden">
            <div 
              className="h-full rounded-full bg-gradient-to-r from-[#ff660e] to-orange-400 animate-pulse transition-all duration-300"
              style={{ width: '100%' }}
            ></div>
          </div>
          <p className="text-xs text-gray-500 mt-2 text-center animate-pulse">
            Please wait while we process your request...
          </p>
        </div>
      )}

      {selectedCount > 0 && !isLoading && (
        <div className="mt-4 pt-4 border-t border-gray-700">
          <div className="flex items-center justify-between text-sm">
            <div className="text-gray-400">
              <span className="text-green-400 font-semibold">✓</span> Ready to perform bulk actions
            </div>
            <div className="flex items-center gap-4">
              <div className="text-gray-400">
                <span className="text-yellow-400 font-semibold">⚠</span> This will affect {selectedCount} listings
              </div>
            </div>
          </div>
        </div>
      )}

      {selectedCount === 0 && (
        <div className="mt-4 pt-4 border-t border-gray-700">
          <div className="text-center py-2">
            <p className="text-sm text-gray-400 flex items-center justify-center gap-2">
              <span>📋</span>
              <span>Select listings to enable bulk actions</span>
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default BulkModerationActions;